module.exports = __webpack_public_path__ + "media/app/components/Overview/delivery.242763a7.svg";